import apiClient from '../client';

export default async function initPayment(processingOrderId: string) {
  return apiClient.processingPaymentFormInitialization({
    processing_order_id: processingOrderId,
  });
}
